import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const CompanyInfoHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Company Information
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Manage your company's profile information that appears across the platform.
            Keep your company details up-to-date for candidates and team members.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Basic Information
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Update essential company details including name, contact information, location,
            and industry. This information is used across job postings and communications.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Company Branding
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Upload and manage your company logo, brand colors, and other visual elements.
            Maintain consistent branding across all platform features.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Company Description
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Create a compelling company description that highlights your mission, values,
            and culture. This information helps attract the right candidates.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Social Media
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Link your company's social media profiles to enhance your employer brand.
            Showcase your company culture and connect with potential candidates.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/account/company-information"
              color="primary"
              variant="contained"
            >
              Update Company Information
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default CompanyInfoHelp; 